import React from "react";

import DiscussionChannelListItem from "./DiscussionChannelListItem";

export default function DiscussionChannelList({ channels, showProductionName }) {
	return (
		<div style={{ maxHeight: "70vh", overflow: "auto", scrollbarWidth: "thin" }}>
			{channels?.map((channel) => {
				return (
					<DiscussionChannelListItem
						key={channel.id}
						channel={channel}
						showProductionName={showProductionName}
					/>
				);
			})}
		</div>
	);
}
